module.exports = __webpack_public_path__ + "img/logo-small.3906b701.svg";